<div class="grid-stack" (contextmenu)="$event.stopPropagation()">
  <ng-template [ngIf]="widgets.length" [ngIfElse]="empty">
    <ng-container *ngFor="let widget of widgets">
      <div
        class="grid-stack-item"
        [attr.gs-w]="widget.width"
        [attr.gs-h]="widget.height"
        [attr.gs-x]="widget.col"
        [attr.gs-y]="widget.row"
        [attr.id]="widget.widget + '__' + widget.id"
        (contextmenu)="$event.stopPropagation()"
      >
        <div class="drag-handle" *ngIf="!widget.isPinned">
          <sn-icon>drag_indicator</sn-icon>
        </div>
        <button
          *ngIf="isDeleting"
          mat-fab
          class="remove"
          [matTooltip]="'dashboard.operational.widgets.deleteWidget' | t"
          (click)="onDeleteWidget(widget)"
        >
          <sn-icon>clear</sn-icon>
        </button>
        <button
          mat-fab
          *ngIf="isEditing"
          class="edit"
          [matTooltip]="'dashboard.operational.widgets.editWidget' | t"
          (click)="edit(widget)"
        >
          <sn-icon fontSet="fas" fontIcon="fa-pen"></sn-icon>
        </button>
        <button
          mat-fab
          *ngIf="isPinning"
          [class.pin]="!widget.isPinned"
          [class.pinned]="widget.isPinned"
          [matTooltip]="!widget.isPinned ? ('dashboard.operational.widgets.pinWidget' | t) : ('dashboard.operational.widgets.unpinWidget' | t)"
          (click)="onPinWidget(widget)"
        >
          <sn-icon>push_pin</sn-icon>
        </button>
        <div class="grid-stack-item-content">
          <ng-container [ngSwitch]="widget.widget">
            <fs-alarms-widget
              [widget]="widget"
              [viewId]="viewId"
              *ngSwitchCase="'alert'"
            ></fs-alarms-widget>
            <sn-camera-live-view-widget
              [widget]="widget"
              [viewId]="viewId"
              *ngSwitchCase="'camera_live_view'"
            ></sn-camera-live-view-widget>
            <sn-camera-grids-widget
              [widget]="widget"
              [viewId]="viewId"
              *ngSwitchCase="'camera_grids'"
            ></sn-camera-grids-widget>
            <sn-analytics-widget
              #analytics
              [widget]="widget"
              [viewId]="viewId"
              *ngSwitchCase="'heatmap_analytics'"
            ></sn-analytics-widget>
            <sn-chat-channel-widget
              [widget]="widget"
              [viewId]="viewId"
              (widgetUpdated)="onWidgetUpdated($event)"
              *ngSwitchCase="'chat_channel'"
            ></sn-chat-channel-widget>
            <sn-embed-youtube-widget
              [widget]="widget"
              [viewId]="viewId"
              *ngSwitchCase="'embed_youtube'"
            ></sn-embed-youtube-widget>
            <sn-embed-code-widget
              [widget]="widget"
              [viewId]="viewId"
              *ngSwitchCase="'embed_code'"
            ></sn-embed-code-widget>
            <sn-facebook-live-widget
              [widget]="widget"
              [viewId]="viewId"
              *ngSwitchCase="'facebook_live'"
            ></sn-facebook-live-widget>
            <sn-content-widget
              [widget]="widget"
              [viewId]="viewId"
              (widgetUpdated)="onWidgetUpdated($event)"
              *ngSwitchCase="'content'"
            ></sn-content-widget>
            <sn-twitter-embed-widget
              [widget]="widget"
              [viewId]="viewId"
              *ngSwitchCase="'twitter_timeline_embed'"
            ></sn-twitter-embed-widget>
            <sn-website-iframe-widget
              [widget]="widget"
              [viewId]="viewId"
              *ngSwitchCase="'website_iframe'"
            ></sn-website-iframe-widget>
            <sn-media-widget
              [widget]="widget"
              [viewId]="viewId"
              *ngSwitchCase="'media_widget'"
            ></sn-media-widget>
          </ng-container>
        </div>
      </div>
    </ng-container>
  </ng-template>
</div>

<ng-template #empty>
  <sn-empty-state icon="cancel_presentation" [title]="'common.noWidgetsFound' | t"> </sn-empty-state>
</ng-template>
